<div
    [ngClass]="{
        'swiper-container': config.containerModifierClass === undefined,
    }"
>
    <ng-content></ng-content>
</div>
